import { render, staticRenderFns } from "./ModalResendActivationLink.vue?vue&type=template&id=30af4808&"
import script from "./ModalResendActivationLink.vue?vue&type=script&lang=js&"
export * from "./ModalResendActivationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports